<template>
  <v-navigation-drawer
    id="appDrawer"
    v-model="drawer"
    :mini-variant.sync="mini"
    fixed
    :dark="$vuetify.dark"
    app
    width="230"
  >
    <v-card
      elevation="0"
      class="app-user rounded-0"
      color="primary"
    >
      <AppUserInfo />
      <!-- <router-link
        to="/"
        title="ARCE - Agência Reguladora do Estado do Ceará"
        class="app-logo"
      >
        <img
          src="https://cdn.arce.ce.gov.br/logo.svg"
          height="auto"
          width="180"
          class="mat-toolbar__img"
          alt="Logo ARCE"
        >
      </router-link> -->
    </v-card>

    <v-subheader class="app-subheader">
      Menu
    </v-subheader>

    <app-side-bar />

    <template #append>
      <div class="pa-2 text-center app-version">
        <span
          class="body-2"
        >&copy; {{ currentYear.getFullYear() }} {{ version }}</span>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import GlobalStore from '@/store/modules/global';
import AppSideBar from '@/components/AppSideBar';
import AppUserInfo from '@/components/AppUserInfo';
import { VERSION_APP } from '@/commons/config';

export default {
  components: {
    AppSideBar,
    AppUserInfo
  },
  data: () => ({
    mini: false,
    version: `v${VERSION_APP}`,
    currentYear: new Date()
  }),
  computed: {
    drawer: {
      get: () => {
        return GlobalStore.drawer;
      },
      set: value => {
        GlobalStore.setDrawer(value);
      }
    }
  },
  created() {
    const { name } = this.$vuetify.breakpoint;
    if (name === 'xs') {
      GlobalStore.setDrawer(false);
    }
  }
};
</script>

<style lang="scss">
#appDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 48px);
    overflow: auto;
  }

  .mat-toolbar__img {
    margin: auto;
    display: table;
  }
}
</style>
